import type { AxiosCustomError } from 'services/http';
import { http } from 'services/http';
import { FAVORITES_GET_MANY } from 'api/query-keys';
import type { TFavoriteColors } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

interface IClearFavoriteColorParams {
  cargoId?: number;
  color?: TFavoriteColors;
}

export const useClearFavorite = () => {
  return useMutationBase<void, AxiosCustomError, IClearFavoriteColorParams>({
    mutationFn: async (variables) => {
      const params = new URLSearchParams();

      if (variables.color) {
        params.append('color', variables.color);
      }

      if (variables.cargoId) {
        params.append('cargoId', variables.cargoId.toString());
      }

      await http.delete(`/v1/favorites?${params.toString()}`);
    },

    invalidateCallback: () => [[FAVORITES_GET_MANY]],
  });
};
